export default "__VITE_ASSET__CEK1r3yv__"